"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedTeamUtilization = void 0;
const AggregatedBudget_1 = require("./AggregatedBudget");
const AggregatedCapacity_1 = require("./AggregatedCapacity");
class AggregatedTeamUtilization {
    constructor(capacity = new AggregatedCapacity_1.AggregatedCapacity(), budget = new AggregatedBudget_1.AggregatedBudget()) {
        this.capacity = capacity;
        this.budget = budget;
    }
    getSummary() {
        const budget = this.getPlannedHours();
        return {
            utilization: Math.round(this.getUtilization()),
            delta: Math.round(this.capacity.allocatedHours - budget),
            customers: this.countCustomers(),
            budget: Math.round(budget),
            engineers: this.countEngineers(),
            capacity: Math.round(this.capacity.allocatedHours),
            consumedBudget: Math.round(this.budget.opsHours + this.budget.teamHours),
        };
    }
    countEngineers() {
        return this.capacity?.getItems().length || 0;
    }
    getCapacity() {
        return this.capacity.allocatedHours;
    }
    countCustomers() {
        return Object.keys(this.budget?.items || {}).length;
    }
    getBudget() {
        return this.budget.opsHours + this.budget.teamHours;
    }
    getPlannedHours() {
        return this.budget.getPlannedHours();
    }
    getDelta() {
        return this.getCapacity() - this.getPlannedHours();
    }
    getUtilization() {
        return (this.getPlannedHours() / this.capacity.allocatedHours) * 100;
    }
    isOverallocated() {
        return this.getPlannedHours() > this.capacity.allocatedHours;
    }
    getEngineersByRegion() {
        return this.capacity.getItems().reduce((all, capacity) => {
            const engineer = capacity.engineer;
            const region = engineer.region;
            const engineers = all.get(region) || [];
            engineers.push(engineer);
            all.set(region, engineers);
            return all;
        }, new Map());
    }
    getEngineersInRegion(region) {
        return this.getEngineersByRegion().get(region) || [];
    }
    getEngineersBySkills() {
        return this.capacity.getItems().reduce((all, capacity) => {
            const engineer = capacity.engineer;
            engineer.skills.forEach((skill) => {
                const engineers = all.get(skill) || [];
                engineers.push(engineer);
                all.set(skill, engineers);
            });
            return all;
        }, new Map());
    }
}
exports.AggregatedTeamUtilization = AggregatedTeamUtilization;
//# sourceMappingURL=AggregatedTeamUtilization.js.map